export default __webpack_public_path__ + "static/media/loader.f19f6b5e.gif";